<template>
  <div class="distributionAudit">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="110px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label-width="90" label="分销商名称">
          <el-input
            clearable
            v-model.trim="formInline.name"
            placeholder="请输入分销商名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsName" label="联系人名称">
          <el-input
            clearable
            v-model.trim="formInline.contactsName"
            placeholder="请输入联系人名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsPhone" label="联系人手机号">
          <el-input
            v-model.trim="formInline.contactsPhone"
            maxlength="11"
            placeholder="请输入联系人手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title">
        <el-button
          v-if="!checkAdmin()"
          size="small"
          type="primary"
          @click="openHandleAgency('distribution_add')"
          >新增分销商</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="分销商名称" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkAdmin()"
          label="所属代理商"
          minWidth="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.targetCompamnyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="logo" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.logo">
              <el-image
                style="width: 60px; height: 60px"
                :src="row.logo"
                :preview-src-list="[row.logo]"
              >
              </el-image>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道来源" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.insertBy && row.insertBy !== '0'"
              >代理商自行合作</el-tag
            >
            <el-tag type="success" v-else>分销商主动合作</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsPhone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!checkAdmin()"
          label="合作状态"
          minWidth="140"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              type="success"
              v-if="row.auditState === 1 && row.proxyAuditState === 1"
              >审核通过</el-tag
            >
            <el-tag
              type="danger"
              v-else-if="row.auditState === 2 || row.proxyAuditState === 2"
              >审核失败</el-tag
            >
            <el-tag v-else>待审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkAdmin()"
          label="审核状态"
          minWidth="140"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.auditState === 1">审核通过</el-tag>
            <el-tag type="danger" v-else-if="row.auditState === 2"
              >审核失败</el-tag
            >
            <el-tag v-else>待审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后操作人" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="210" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span
              v-if="!checkAdmin() && row.auditState === 2"
              class="blue_Box"
              @click="openHandleAgency('distribution_alter', row)"
              >编辑</span
            >
            <span
              class="blue_Box"
              v-if="row.auditState === 0 && checkAdmin()"
              @click="auditCooperationApply(row)"
              >分销商审核</span
            >
            <a
              href="javascript:;"
              :disabled="!row.rejectNum"
              @click="openAuditFailReason(row)"
              >审核驳回原因</a
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <HandleAgency ref="handleAgencyRef" statusPage="audit" />
    <!-- 审核驳回原因 -->
    <AuditFailReason ref="auditFailReasonRef" />
  </div>
</template>

<script>
import AuditFailReason from "@/views/organization/components/auditFailReason.vue";
import HandleAgency from "@/views/organization/components/handleAgency.vue";
import { getCooperationApplyListPage } from "@/api/organization";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "DistributionAudit",
  components: {
    myPagination,
    HandleAgency,
    AuditFailReason,
  },
  data() {
    return {
      loading: false,
      formInline: {
        name: "",
        contactsName: "",
        contactsPhone: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  mounted() {
    this.getCooperationApplyListPage({ page: 1, limit: 10 });
  },
  methods: {
    // 审核驳回原因
    openAuditFailReason(payload) {
      let status = "2";
      this.$refs.auditFailReasonRef.init(status, payload.licenseNum);
    },
    // 刷新
    refresh() {
      this.getCooperationApplyListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getCooperationApplyListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      if (this.checkAdmin()) {
        payload.proxyAuditState = 1;
      }
      const res = await getCooperationApplyListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 添加、编辑
    openHandleAgency(status, payload) {
      this.$refs.handleAgencyRef.init(status, payload);
    },
    // 分销商审核
    auditCooperationApply(payload) {
      this.$refs.handleAgencyRef.init("distribution_audit", payload);
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getCooperationApplyListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getCooperationApplyListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCooperationApplyListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCooperationApplyListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.distributionAudit {
  .title {
    margin: 0px 0 10px;
  }

  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
